import axios from "axios";
import { LOCAL_STORAGE } from "../../utils/constants";

const CreateAxios = (props = {}) => {
  var gett = LOCAL_STORAGE.userToken
  var customerNo = LOCAL_STORAGE.customerNo;
  var userId = LOCAL_STORAGE.userId;
  var locales = LOCAL_STORAGE.locales === "en" ? "en-IN" : "pt-BR"
  let congData = JSON.stringify({
    customerNumber: customerNo,
    userId: userId,
    customer_no: +customerNo,
    customerNo: +customerNo,
    user_id: +userId,
    ...props.payload
    // jsonreq: props.jsonreq
  });

  const apiURL = props.completeURL
    ? `${props.completeURL}`
    : `${process.env.REACT_APP_BASE_URL}/masters/${props.url}`;

  if (props.completeURL) {
    try {
      return new Promise((resolve, reject) => {
        axios
          .post(apiURL, congData, {
            headers: {
              Accept: "application/json",
              "Content-Type": "application/json",
              "Access-Control-Allow-Headers": "*",
              crossorigin: true,
              Authorization: `${gett}`,
              "Accept-Language": locales,
              ...props.headersExtra
            },
          })
          .then((res) => {
            if (res.status === 1) {
              resolve(res);
            } else {
              console.log("Error", res.data);
              resolve(res);
            }
            resolve(res);
          })
          .catch((err) => {
            console.log("err", err.data);
            reject(err);
          });
      });
    } catch (error) {
      return console.log("Error Create", error);
    }
  }
  else if (props.publicURL) {
    try {
      return new Promise((resolve, reject) => {
        axios
          .post(props.publicURL, congData, {
            headers: {
              Accept: "application/json",
              "Accept-Language": locales
            },
          })
          .then((res) => {
            resolve(res);
          })
          .catch((err) => {
            console.log("err", err.data);
            reject(err);
          });
      });
    } catch (error) {
      return console.log("Error Create", error);
    }
  }
  else {
    try {
      return new Promise((resolve, reject) => {
        axios
          .put(apiURL, congData, {
            headers: {
              Accept: "application/json",
              "Content-Type": "application/json",
              Authorization: `${gett}`,
              "Accept-Language": locales
            },
          })
          .then((res) => {
            if (res.data.status === 200 || res.data.status === 201) {
              resolve(res);
            } else {
              console.log("Error", res.data);
              reject(res);
            }
          })
          .catch((err) => {
            console.log("err", err.response);
            reject(err);
          });
      });
    } catch (error) {
      return console.log("Error Create", error);
    }
  }
};

export default CreateAxios;
